import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=886b3ba4&scoped=true"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886b3ba4",
  null
  
)

export default component.exports